import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { USERS_VERIFICATION_URL } from 'constants/routes';
import useLocation from 'hooks/useLocation';
import { getModalDisplayStatus } from 'state/banners/selectors';
import { getIsPromoShown } from 'state/profile/selectors';
const BLACKLISTED_PATHS = [USERS_VERIFICATION_URL];

const isPathBlackListed = path => BLACKLISTED_PATHS.some(blackListedPath => path.startsWith(blackListedPath));

export default function useManageInAppMessage(inAppMessageProvider) {
  const couldOnboardingModalBeShown = useSelector(getModalDisplayStatus) !== 'not shown';
  const isProfilePromoShown = useSelector(getIsPromoShown);
  const {
    relativeUrl
  } = useLocation();
  const isAnyModalShown = couldOnboardingModalBeShown || isProfilePromoShown;
  const shouldEnable = !isPathBlackListed(relativeUrl) && !isAnyModalShown;
  useEffect(() => {
    if (!inAppMessageProvider) return;

    if (shouldEnable) {
      inAppMessageProvider.enable();
      inAppMessageProvider.publishStoredMessages();
    } else {
      inAppMessageProvider.disable();
    }
  }, [inAppMessageProvider, shouldEnable]);
}